// removed by extract-text-webpack-plugin
module.exports = {"errorRed":"#DC001C","large":"only screen and (min-width: 993px)","container":"container-1bk-P","header":"header-2pQ0M","infoBox":"infoBox-3mztn","icon":"icon-3b9FZ","iconWrapper":"iconWrapper-2PylX","MMRIcon":"MMRIcon-ZL5xz","numberIcon":"numberIcon-fZCbk","buttonWrapper":"buttonWrapper-y8kFE","button":"button-4FOrJ button-97MMb undefined","forgot":"forgot-Sj3uL","connectHeader":"connectHeader-346p- undefined"};


//////////////////
// WEBPACK FOOTER
// ./src/components/samsung_gear_connect/_samsung_gear_connect.css
// module id = 1275
// module chunks = 1